import React from 'react';
import noop from 'lodash/noop';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller';
import { Minimap as MinimapBoardKit, MinimapColumn } from '@atlassian/jira-platform-board-kit';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { useColumns } from '../../../controllers/columns-old';

export const Minimap = () => {
	const columns = useColumns();

	return (
		<UFOSegment name="business-board-minimap-old">
			<JiraBottomRightCornerOutlet orderFromRight={2} id="business-board-minimap">
				<MinimapBoardKit onScrollAttempted={noop} onShow={noop}>
					{columns.map((column) => (
						<MinimapColumn key={column.statusId} />
					))}
				</MinimapBoardKit>
			</JiraBottomRightCornerOutlet>
		</UFOSegment>
	);
};
